<template>
  <div class="dialog-margin">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="订单" name="1" v-if="userName === '大货'">
        <el-form inline @submit.native.prevent>
          <el-form-item label="销售订单编号">
            <el-input v-model="searchValue.saleOrderNo" @keyup.enter.native="search"/>
          </el-form-item>
          <el-form-item label="物品编号">
            <el-input v-model="searchValue.goodsNo" @keyup.enter.native="search"/>
          </el-form-item>
          <el-form-item label="下单日期:">
            <el-date-picker v-model="searchValue.orderTimeStart"
                            type="date"
                            placeholder="请选择开始日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"/>
            -
            <el-date-picker v-model="searchValue.orderTimeEnd"
                            type="date"
                            placeholder="请选择结束日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"/>
          </el-form-item>
          <el-form-item>
            <div class="control-button">
              <el-button type="primary" @click="search">查询</el-button>
              <el-button type="primary" @click="clearSearch">清空</el-button>
            </div>
          </el-form-item>
        </el-form>
        <el-form inline>
          <el-form-item>
            <el-checkbox v-model="isSurplus" @change="search">库存剩余量>0</el-checkbox>
          </el-form-item>
        </el-form>
        <el-table :data="orders" :loading="loading" max-height="426px"
                  @selection-change="handleSelectionChange">
          <template slot="empty">
            <span style="color: #969799;font-size: 24px">{{loadInfo}}</span>
          </template>
          <el-table-column type="selection" width="55"/>
          <el-table-column prop="saleOrderNo" label="销售订单编号"/>
          <el-table-column label="物品编号" prop="goodsNo"/>
          <el-table-column label="别称" prop="goodsName"/>
          <el-table-column prop="mainQuantity" label="订单数量"/>
          <el-table-column prop="mainQuantityUnit" label="单位"/>
          <el-table-column prop="noticeCount" label="已通知发货数量"/>
          <el-table-column prop="shipmentCount" label="已发货数量"/>
          <el-table-column prop="quantity" label="订单剩余库存数量"/>
          <el-table-column label="下单日期" prop="gmtCreate" width="200"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="现货" name="2">
        <el-form inline @submit.native.prevent>
          <el-form-item label="物品编号">
            <el-input v-model="searchValue.goodsNo" @keyup.enter.native="search"/>
          </el-form-item>
          <el-form-item>
            <div class="control-button">
              <el-button type="primary" @click="search">查询</el-button>
              <el-button type="primary" @click="clearSearch">清空</el-button>
            </div>
          </el-form-item>
        </el-form>
        <el-table :data="orders" :loading="loading" max-height="426px"
                  @selection-change="handleSelectionChange">
          <template slot="empty">
            <span style="color: #969799;font-size: 24px;">{{loadInfo}}</span>
          </template>
          <el-table-column type="selection" width="55"/>
          <el-table-column label="物品编号" prop="goodsNo" width="200"/>
          <el-table-column label="别称" prop="goodsName"/>
          <el-table-column label="门幅" prop="width"/>
          <el-table-column label="克重" prop="weight"/>
          <el-table-column label="成分" prop="blendName"/>
          <el-table-column prop="quantityShow" label="库存剩余数量"/>
          <el-table-column prop="mainQuantityUnit" label="单位"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="转入订单" name="4" v-if="userName === '大货'">
        <el-form inline @submit.native.prevent>
          <el-form-item label="销售订单编号">
            <el-input v-model="searchValue.saleOrderNo" @keyup.enter.native="search"/>
          </el-form-item>
          <el-form-item label="物品编号">
            <el-input v-model="searchValue.goodsNo" @keyup.enter.native="search"/>
          </el-form-item>
          <el-form-item>
            <div class="control-button">
              <el-button type="primary" @click="search">查询</el-button>
              <el-button type="primary" @click="clearSearch">清空</el-button>
            </div>
          </el-form-item>
        </el-form>
        <el-table :data="orders" :loading="loading" max-height="426px"
                  @selection-change="handleSelectionChange">
          <template slot="empty">
            <span style="color: #969799;font-size: 24px;">{{loadInfo}}</span>
          </template>
          <el-table-column type="selection" width="55"/>
          <el-table-column prop="saleOrderNo" label="销售订单编号"/>
          <el-table-column label="物品编号" prop="goodsNo"/>
          <el-table-column label="别称" prop="goodsName"/>
          <el-table-column prop="transferOrderNums" label="转入订单数量"/>
          <el-table-column prop="mainQuantityUnit" label="单位"/>
          <el-table-column label="入库时间" prop="operateTime" width="200"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="转入现货" name="5">
        <el-form inline @submit.native.prevent>
          <el-form-item label="物品编号">
            <el-input v-model="searchValue.goodsNo" @keyup.enter.native="search"/>
          </el-form-item>
          <el-form-item>
            <div class="control-button">
              <el-button type="primary" @click="search">查询</el-button>
              <el-button type="primary" @click="clearSearch">清空</el-button>
            </div>
          </el-form-item>
        </el-form>
        <el-table :data="orders" :loading="loading" max-height="426px"
                  @selection-change="handleSelectionChange">
          <template slot="empty">
            <span style="color: #969799;font-size: 24px;">{{loadInfo}}</span>
          </template>
          <el-table-column type="selection" width="55"/>
          <el-table-column label="物品编号" prop="goodsNo"/>
          <el-table-column label="别称" prop="goodsName"/>
          <el-table-column prop="transferOrderNums" label="转入现货申请数量"/>
          <el-table-column prop="mainQuantityUnit" label="单位"/>
          <el-table-column prop="quantity" label="库存剩余数量"/>
          <el-table-column label="入库时间" prop="operateTime" width="200"/>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div class="control-button padding-10">
      <el-button type="primary" @click="select">选中</el-button>
      <el-button @click="close">关闭</el-button>
    </div>
  </div>
</template>

<script>
/**
 * @Description: 销售订单选择弹窗
 * @Author: 菩萨蛮
 * @Date: 2020/9/28 10:26 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 *
 */
import qs from 'qs';

export default {
  name: 'SaleOrderDialog',
  props: {
    goodsType: { type: null, default: 1 },
    currencyUnit: { type: String, default: '人民币' },
    custName: { type: String },
    userName: { type: String },
    isSelectedOrder: { type: Array, default: () => [] },
    unitList: { type: Array },
    orderOperatorId: { type: Number, default: null },
    simpleType: { type: String, default: '' },
  },
  data() {
    return {
      isSurplus: true,
      loadInfo: '',
      activeName: this.userName === '样品' ? '2' : '1',
      loading: false,
      searchValue: {
        saleOrderNo: '',
        goodsNo: '',
        orderId: '',
        orderTimeStart: null,
        orderTimeEnd: null
      },
      orders: [],
      selectRow: [],
      time: ''
    };
  },
  computed: {
    unit() {
      return this.goodsType === 3 ? 'kg' : '米';
    }
  },
  created() {
    this.search();
  },
  methods: {
    handleClick() {
      this.search();
    },
    search() {
		    this.time = new Date().getTime(); //主要是这里，记录当前点击的时间戳
		    this.getData(this.time);
		},
    async getData(time) {
      this.orders = [];
      this.loadInfo = '载入中';
      this.loading = true;
      let p = [];
      const { orderTimeStart, orderTimeEnd } = this.searchValue;
      // 随便写的，吃屎去吧
      if (orderTimeStart === null && orderTimeEnd !== null) {
        p = ['1970-01-01', orderTimeEnd];
      }
      if (orderTimeStart !== null && orderTimeEnd !== null) {
        p = [orderTimeStart, orderTimeEnd];
      }
      if (orderTimeStart !== null && orderTimeEnd === null) {
        p = [orderTimeStart, '2099-01-01'];
      }
      if (this.activeName === '4' || this.activeName === '5') {
        this.searchValue = {
          ...this.searchValue,
          orderOperatorIdForNotice: this.orderOperatorId
        };
      } else {
        delete this.searchValue.orderOperatorIdForNotice;
      }

      let queryType = '';
      if (this.activeName === '1') {
        if (this.isSurplus) {
          queryType = '3';
        } else {
          queryType = '1';
        }
      } else {
        queryType = this.activeName;
      }
      if (this.simpleType) {
        this.searchValue = {
          ...this.searchValue,
          simpleType: this.simpleType
        };
      } else {
        delete this.searchValue.simpleType;
      }

      const { data } = await this.qGet({
        notEncode: true,
        url: `/sales/sale_order/notice?${qs.stringify({
          status: [2, 3, 4, 5],
          goodsType: this.goodsType,
          custName: this.custName,
          orderOperatorName: this.userName,
          placeOrderDate: p,
          type: '大货',
          queryType,
          ...this.searchValue
        })}&pageSize=30`
      });
      if (time === this.time) {
        if (data && data.datas) {
          const goodsList = data.datas.map(e => ({
            ...e,
            ...e.goodsInfo,
            orderId: e.id,
            saleOrderQuantity: e.goodsInfo.mainQuantity,
            saleUnit: e.goodsInfo.mainQuantityUnit,
            remark: '',
            settlePlans: e.settlePlans
          }));
          const isSelectedOrderJson = this.isSelectedOrder.map(e => JSON.stringify({
            orderId: e.orderId,
            goodsNo: e.goodsNo
          }));
          this.orders = goodsList;
          // this.orders = goodsList.filter(d => !isSelectedOrderJson.includes(JSON.stringify({
          //   orderId: d.orderId,
          //   goodsNo: d.goodsNo
          // })));
          if (this.activeName === '2') {
            this.orders.forEach(item => {
              item.quantityShow = item.quantity;
              if (this.userName === '大货' && item.quantity > 3000) {
                item.quantityShow = '3000+';
              }
              if (this.userName === '样品' && item.quantity > 100) {
                item.quantityShow = '100+';
              }
            });
          }
          if (this.orders.length === 0) {
            this.loadInfo = '暂无数据';
          }
        } else {
          this.loadInfo = '暂无数据';
        }
      }
      this.loading = false;
    },
    clearSearch() {
      this.searchValue = this.$options.data().searchValue;
    },
    handleSelectionChange(row) {
      this.selectRow = row;
    },
    select() {
      this.$emit('select', this.selectRow.map(e => {
        let noticeMainCount = null;
        if (this.activeName === '1') {
          if (this.isSurplus) {
            noticeMainCount = e.quantity;
          } else {
            noticeMainCount = e.mainQuantity;
          }
        }
        if (this.activeName === '2') {
          noticeMainCount = undefined;
        }
        if (this.activeName === '4' || this.activeName === '5') {
          noticeMainCount = e.transferOrderNums;
        }
        return {
          ...e,
          orderCount: e.orderCountMeterOrKg,
          noticeMainUnit: e.mainQuantityUnit,
          noticeMainUnitId: this.unitList.find(i => i.unit === e.mainQuantityUnit).id,
          noticeMainCount,
          goodsWeight: 0,
          orderType: this.activeName,
          batchList: []
        }
      }));
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
